export default __webpack_public_path__ + "static/media/platform-event-logo.588199f8.svg";